import { render, staticRenderFns } from "./CardFairSeries.vue?vue&type=template&id=31eac7fa&scoped=true"
import script from "./CardFairSeries.vue?vue&type=script&lang=js"
export * from "./CardFairSeries.vue?vue&type=script&lang=js"
import style0 from "./CardFairSeries.vue?vue&type=style&index=0&id=31eac7fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eac7fa",
  null
  
)

export default component.exports